import { IoPersonSharp } from 'react-icons/io5'
import { FaPhone } from 'react-icons/fa6'
import { useSelector } from 'react-redux'
import { DecodeHtml } from '../../utils/decodeHtml'
import { PropTypes } from 'prop-types'
import { useEffect, useState } from 'react'

export const MyTable = ({
  headers,
  mobile,
  contents,
  headerBg = 'border-gray-300/50 bg-indigo-100'
}) => {
  const cellPercentage = 100 / headers?.length
  const maxLengthOfContent = contents?.reduce(
    (acc, curr) => Math.max(acc, curr.length),
    0
  )

  return (
    <div className='table-responsive table-condensed'>
      <table className='table'>
        <thead>
          <tr>
            {headers?.map((header, index) => (
              <th
                key={index}
                className={`text-left lg:border-2 lg:w-[${cellPercentage}%]  p-4 ${headerBg}`}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: maxLengthOfContent }).map((_, i) => {
            return (
              <tr key={i}>
                {contents?.map((content, index) => {
                  return (
                    <td
                      data-label={mobile ? mobile[index] : headers[index]}
                      className={`text-left px-8 align-top lg:border-2 lg:w-[${cellPercentage}%]  p-4 bg-slate-50`}
                      key={index}
                    >
                      {content[i]}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
MyTable.propTypes = {
  headers: PropTypes.array,
  mobile: PropTypes.array,
  contents: PropTypes.array,
  headerBg: PropTypes.string
}

const SwimmingPoolHours = () => {
  const state = useSelector(state => state.campusLifeTab)

  const swimmingPool = state?.data?.properties

  const feeWeekdaysRMPerSession = DecodeHtml({
    html: swimmingPool?.feeWeekdaysRMPerSession?.markup
  })
  const feeSundayNightRMPerSession = DecodeHtml({
    html: swimmingPool?.feeSundayNightRMPerSession?.markup
  })

  const [tableData, setTableData] = useState({
    headers: [],
    mobile: [],
    contents: []
  })

  useEffect(() => {
    const headers = []
    const mobile = []
    const contents = []

    swimmingPool?.swimmingPoolOperationHoursTable?.items.forEach(item => {
      // Extract the label for the header
      const headerLabel = item?.content?.properties?.label
      headers.push(headerLabel)
      mobile.push(headerLabel)

      const rowData = []
      item?.content?.properties?.content?.items?.forEach(contentItem => {
        // Extract the content for each cell
        const cellContent = contentItem?.content?.properties?.richText?.markup
        rowData.push(DecodeHtml({ html: cellContent }))
      })
      contents.push(rowData)
    })

    setTableData({ headers, mobile, contents })
  }, [swimmingPool?.swimmingPoolOperationHoursTable])

  const swimmingPoolEnquiryContacts =
    swimmingPool?.swimmingPoolEnquiryContacts?.items?.map(item => {
      return DecodeHtml({ html: item?.content?.properties?.label?.markup })
    })

  return (
    <div className='w-full flex flex-col  gap-2 my-5'>
      <h1 className='w-auto   text-slate-900 text-2xl font-bold  uppercase'>
        SWIMMING POOL OPERATION HOURS
      </h1>
      <div className='grid grid-cols-1 lg:grid-cols-[70%_30%] gap-8'>
        <div className='w-full flex items-center justify-center'>
          <MyTable
            headers={tableData.headers}
            mobile={tableData.mobile}
            contents={tableData.contents}
          />
        </div>
        <div className='flex flex-col gap-7 w-full'>
          <div className='flex flex-col gap-5'>
            <h2 className='w-auto   text-slate-900 text-xl font-bold  capitalize'>
              Fee Weekdays (RM) Per Session
            </h2>
            {feeWeekdaysRMPerSession}
          </div>
          <div className='flex flex-col gap-5'>
            <h2 className='w-auto   text-slate-900 text-xl font-bold  capitalize'>
              Fee Sunday/Night (RM) Per Session
            </h2>
            {feeSundayNightRMPerSession}
          </div>
        </div>
      </div>
      <div className='flex flex-col gap-3 my-3'>
        <span className='text-base font-semibold underline leading-normal flex whitespace-nowrap  items-center '>
          <div className='w-8'>
            <IoPersonSharp size={20} />
          </div>
          {swimmingPoolEnquiryContacts != null &&
            swimmingPoolEnquiryContacts[0]}
        </span>
        <span className='text-base font-normal leading-normal flex items-center  whitespace-nowrap '>
          <div className='w-8'>
            <FaPhone size={20} />
          </div>
          {swimmingPoolEnquiryContacts != null &&
            swimmingPoolEnquiryContacts[1]}
        </span>
      </div>
    </div>
  )
}

export default SwimmingPoolHours
